<template>
  <div>
    <vx-card style="margin-bottom: 15px">
      <b-row align-v="center">
        <b-col lg="2" sm="5">
          <b-form-input
            v-model="arananDeger"
            @keyup.enter="getOdemeHatirlatmaList"
            id="smallInput"
            placeholder="Cari No/Adı"
          />
        </b-col>
        <b-col lg="2" sm="5">
          <v-select
            v-model="secilenDonem"
            :options="donemList"
            class="select-size-sm"
            label="YILAY"
            placeholder="Dönem"
            style=""
          >
          </v-select>
        </b-col>
        <b-col lg="2" sm="5">
          <v-select
            v-model="secilenDurum"
            :options="durumList"
            placeholder="Durum"
            style=""
          >
          </v-select>
        </b-col>
        <b-col lg="2" sm="2">
          <vs-button
            style="border-radius: 5px; width: 100%"
            type="gradient"
            size=""
            @click="listele()"
            id="button-with-loading-yeni"
            class="vs-con-loading__container"
            >Listele</vs-button
          >
        </b-col>
        <!--
        <b-col lg="2" sm="2">
          <vs-button
            style="border-radius: 5px"
            type="gradient"
            size=""
            @click="activePromptToPaymentNotification = true"
            color="danger"
            id="button-with-loading-tekrar"
            class="vs-con-loading__container"
            >{{ tekrartitle }}</vs-button
          >
        </b-col>
        -->
      </b-row>
    </vx-card>
    <vx-card>
      <b-row style="margin-bottom: 10px">
        <b-col cols="2">
          <ButtonPrimary
            :color="filtrecolor"
            :size="size"
            :title="title"
            @test-click="resetState"
          />
        </b-col>
        <b-col cols="6"></b-col>
        <b-col cols="4" style="padding: 0; padding-right: 20px">
          <b-row align-h="end">
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="primary"> Görüldü </vs-chip>
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="success"> Onaylandı </vs-chip>
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="danger"> Red Edildi </vs-chip>
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="warning"> Mail Gönderildi </vs-chip>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <ag-grid-vue
        style="width: 100%; height: 500px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        :pagination="true"
        @selection-changed="onSelectionChanged"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :rowClassRules="rowClassRules"
        :isRowSelectable="isRowSelectable"
        :rowSelection="rowSelection"
        @filter-changed="onFilterChanged"
        :suppressRowClickSelection="true"
        @filter-modified="onFilterModified"
      >
      </ag-grid-vue>
    </vx-card>
    <OdemeBildirimiPopup
      :isSidebarActive="isSidebarActiveGm"
      :data="selectedDataFor"
      @closeSidebar="toggleDataSidebar"
    />
    <vs-prompt
    title="Ödeme Hatırlatması"
    acceptText="Gönder"
    cancelText="İptal"
    :active.sync="activePromptToPaymentNotification"
    @accept="tekrarGonder"
    color="danger"
  >
    <div class="con-exemple-prompt">
      <b-row style="align-items: center">
        <b-col lg="12">
          <h5>
            Tüm carilere Ödeme Hatırlatması gönderme işlemini onaylıyor musunuz?
          </h5>
           
        </b-col>
      </b-row>
    </div>
  </vs-prompt>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import TahsilatRaporDetay from "../components/crm-components/finans-components/TahsilatRaporDetay.vue";
import ButtonPrimary from "../components/crm-components/global-components/ButtonPrimary.vue";
import vSelect from "vue-select";
import { BBadge } from "bootstrap-vue";
import OdemeBildirimiPopup from "./CellRenderers/OdemeBildirimiPopup.vue";
import guncelMutabakatCellRenderer from "./CellRenderers/guncelMutabakatCellRenderer.vue";
export default {
  data() {
    return {
      activePromptToPaymentNotification:false,
      selectedDataFor: "",
      selectedData: [],
      isSidebarActiveGm: false,
      tekrarcolor: "danger",
      tekrartitle: "Tekrar Gönder",
      listsize: "",
      listtitle: "Listele",
      size: "small",
      title: "Filtrelemeyi Resetle",
      filtrecolor: "success",
      isRowSelectable: null,
      rowClassRules: null,
      durumList: [
        "Tümü",
        "Hazır",
        "Gönderildi",
        "Görüldü",
        "Onaylandı",
        "Red Edildi",
        "Hata",
      ],
      secilenDurum: "",
      frameworkComponents: null,
      localeText: null,
      columnDefs: null,
      rowData: null,
      datepickerbaslangic: "",
      datepickerbitis: "",
      columnApi: null,
      arananDeger: "",
      dir: false,
      searchTerm: "",
      pageLength: 10,
      rows: [],
      columns: null,
      rowSelection: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      donemList: [],
      secilenDonem: "",
      secilenRaporlar: [],
      gelenfiltre: "",
    };
  },
  components: {
    guncelMutabakatCellRenderer,
    OdemeBildirimiPopup,
    ButtonPrimary,
    AgGridVue,
    TahsilatRaporDetay,
    "v-select": vSelect,
    BBadge,
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        headerName: "Cari No",
        field: "ACTID",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Dönem",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "YILAY",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Mail",
        field: "EMAIL",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "İşlem Tarihi",
        field: "ISLEMTARIHI",
        sortable: true,
        filter: "agTextColumnFilter",

        valueFormatter: this.parseDate,
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Borç",
        field: "BORC",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.BORC, "₺"),
      },
      {
        headerName: "Alacak",
        field: "ALACAK",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.ALACAK, "₺"),
      },
      {
        headerName: "Bakiye",
        field: "BAKIYE",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.BAKIYE, "₺"),
      },
      {
        headerName: "Gönderi Key",
        field: "GONDKEY",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Durum",
        field: "DURUM",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Red Sebep",
        field: "REDSEBEP",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Güncel Mutabakat Durumu",
        cellRenderer: "guncelMutabakatCellRenderer",
      },
    ];
  },
  created() {
    this.rowSelection = "multiple";
    this.rowClassRules = {
      "green-row": 'data.DURUM == "Onaylandı"',
      "blue-row": 'data.DURUM == "Görüldü"',
      "yellow-row": 'data.DURUM == "Gönderildi"',
      "red-row": 'data.DURUM == "Red Edildi"',
    };
    this.isRowSelectable = (node) => {
      return node.data
        ? node.data.DURUM === "Görüldü" ||
            node.data.DURUM === "Gönderildi" ||
            node.data.DURUM === "HAZIR" ||
            node.data.DURUM === "Hata" ||
            node.data.DURUM === "Red Edildi"
        : false;
    };

    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.getOdemeDonemList();
  },
  methods: {
    guncelMutabakatList(item) {
      this.isSidebarActiveGm = true;
    },
    toggleDataSidebar(val = false) {
      try {
        this.isSidebarActiveGm = val;
      } catch (error) {
        console.log(error);
      }
    },

 
    currencyFormatter(currency, sign) { 
      if (currency == "" || currency == null || typeof currency == "undefined") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
    resetState() {
      this.gridApi.setFilterModel(null);
      this.gelenfiltre = "";
      this.getOdemeHatirlatmaList();
    },
    onFilterChanged(e) {
      var savedFilterModel = e.api.getFilterModel();
      var keys = Object.keys(savedFilterModel);

      if (keys.length > 1) {
        console.log("arama yapma");
      } else {
        var vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;
        if (vm.gelenfiltre == "") {
          vm.getOdemeHatirlatmaList();
        } else {
          const args = {
            token: Store.state.tokenId,
            ARANAN: vm.gelenfiltre,
            DURUM: vm.secilenDurum,
            DONEM: vm.secilenDonem.YILAY,
          };
          if (
            vm.secilenDonem.YILAY != "" &&
            typeof vm.secilenDonem.YILAY != "undefined"
          ) {
            soap.createClient(url, function (err, client) {
              client.INT_MUTABAKAT_RAPORU(args, function (err, result) {
                if (result.INT_MUTABAKAT_RAPORUResult == "-1") {
                  Store.dispatch("logout");
                  //this.$store.dispatch('login', payload)
                }
                try {
                  vm.veriler = JSON.parse(result.INT_MUTABAKAT_RAPORUResult);
                  if (vm.veriler.response == "Ok") {
                    var list = JSON.parse(vm.veriler.jsonData);
                    vm.rowData = list;
                  } else {
                  }
                } catch (error) {}

                //  vm.cariHareketlerListesi = vm.veriler;
              });
            });
          } else {
            const vs = this.$vs;
            vs.notify({
              title: "Mutabakat Raporu",
              text: "Dönem değeri giriniz.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          }
        }
      }
    },
    onFilterModified(e) {
      if (e.filterInstance.getModelFromUi() == null) {
        this.gelenfiltre = "";
      } else this.gelenfiltre = e.filterInstance.getModelFromUi().filter;
    },

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    tekrarGonder() {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#640064",
        color: "#fff",
        container: "#button-with-loading-tekrar",
        scale: 0.45,
      });
      const soap = require("soap");
      const url = state.sistemAddress;
      vm.secilenRaporlar.forEach((val, index) => {
        const args = {
          token: Store.state.tokenId, 
        };
        soap.createClient(url, function (err, client) {
          client.INT_ODEME_HATIRLATMASI(args, function (err, result) {
            if (result.INT_ODEME_HATIRLATMASIResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_ODEME_HATIRLATMASIResult);
              if (vm.veriler.response == "Ok") {
                vs.loading.close("#button-with-loading-tekrar > .con-vs-loading");
                vm.getOdemeHatirlatmaList();
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }
            } catch (error) {
              vs.notify({
                title: "Hata",
                text: "Tekrar gönderilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          });
        });
      });
    },
    listele() {
      this.getOdemeHatirlatmaList();
    },
    onSelectionChanged(params) {
      // this.$store.commit("account/SATINALMA_TUR", this.tur);
      var selectedRows = this.gridApi.getSelectedRows();
      this.secilenRaporlar = selectedRows;
    },
    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.getOdemeHatirlatmaList();
    },
    getNow() {
      const today = new Date();
      const date =
        today.getDate() + "." + (today.getMonth() + 1) + "." + today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    getLastTreeMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d.toLocaleDateString();
    },
    getOdemeDonemList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        isType: "Odeme",
      };
      soap.createClient(url, function (err, client) {
        client.INT_MUTABAKAT_DONEM(args, function (err, result) {
          if (result.INT_MUTABAKAT_DONEMResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_MUTABAKAT_DONEMResult);
            vm.donemList = vm.veriler;
            //  vm.rowData = vm.veriler;
            //  vm.cariHareketlerListesi = vm.veriler;
          } catch (error) {}
        });
      });
    },
    getOdemeHatirlatmaList(aranan) {
      var vm = this;

      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ARANAN: vm.arananDeger,
        DURUM: vm.secilenDurum,
        DONEM: vm.secilenDonem.YILAY,
        isDue: "Odeme",
      };
      if (vm.secilenDonem.YILAY != "" && typeof vm.secilenDonem.YILAY != "undefined") {
        soap.createClient(url, function (err, client) {
          client.INT_MUTABAKAT_RAPORU(args, function (err, result) {
            if (result.INT_MUTABAKAT_RAPORUResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_MUTABAKAT_RAPORUResult);
              if (vm.veriler.response == "Ok") {
                var list = JSON.parse(vm.veriler.jsonData);
                vm.rowData = list;
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }
            } catch (error) {
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          });
        });
      } else {
        vs.notify({
          title: "Mutabakat Raporu",
          text: "Dönem değeri giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
        vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
      }
    },
    direction() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  mounted() {
    this.$root.$on("guncelMutabakatList", (stokDetayVal) => {
      this.selectedDataFor = stokDetayVal.data;
      this.guncelMutabakatList(stokDetayVal.data);
    });
  },
  beforeDestroy() {
    this.$root.$off("guncelMutabakatList");
  },
};
</script>

<style lang="scss">
@import "~ag-grid-community/dist/styles/ag-grid.css";
@import "~ag-grid-community/dist/styles/ag-theme-alpine.css";

.ag-theme-alpine .ag-row {
  font-size: 13px;
  height: 35px;
}
.green-row {
  background-color: #48da89 !important;
}
.yellow-row {
  background-color: #ffb976 !important;
}

.red-row {
  background-color: #f08182 !important ;
}

.blue-row {
  background-color: #9e95f5 !important;
}
.sick-days-warning {
  background-color: sandybrown !important;
}
</style>
